import { createFileRoute, redirect } from '@tanstack/react-router'
import { AUTH_SESSION_STALE_TIME } from '@/trpc/context.ts'

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.fetchQuery({
      ...context.trpc.auth.session.queryOptions(),
      retry: false,
      staleTime: AUTH_SESSION_STALE_TIME
    })

    if (!session) {
      throw redirect({ to: '/auth/signin', replace: true })
    }
    throw redirect({
      to: session.status === 'active' && session.member ? '/home' : '/auth/status',
      replace: true
    })
  }
})
